module.exports = __webpack_public_path__ + "media/images/title_bg_horizontal-56f18032d5112ac1156082a6f1e36bd7.png";